export default "__VITE_ASSET__76537e37__"